import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Fade } from '@material-ui/core';

import useAuth from '../Context/hooks/useAuth';
import styled from 'styled-components';

import { toast } from 'react-toastify';
import api from '../api';

//const img = '';
let imagens ={
    0 : 'https://atsinformatica.com.br/wp-content/uploads/2017/01/iStock-501208219-1-724x480.jpg',
    1 : 'https://blog.brwsuprimentos.com.br/wp-content/uploads/2019/02/original-de1fce95c40fb95189b0fde1574a462f-940x628.jpg',
    2 : 'https://www.redoma.com.br/blog/wp-content/uploads/2020/10/Os-materiais-de-papelaria-continuam-a-todo-vapor-1024x569.jpg'
} 

let min = Math.ceil(0);
let max = Math.floor(Object.keys(imagens).length);

const img = imagens[Math.floor(Math.random() * (max - min)) + min];


let cores ={
    0 : 'rgb(217 43 186 / 90%)',
    1 : 'rgb(51 210 131 / 90%)',
    2 : 'rgb(230 161 28 / 90%)',
    3 : 'rgb(192 28 230 / 90%)',
    4 : 'rgb(61 28 230 / 90%)',
    5 : 'rgb(230 28 28 / 90%)',
    6 : 'rgba(43,144,217,0.9)'
} 


const Hover =  styled.div`

    background: url(${img});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;   
`;

const LoginContainer =  styled.div`
    display: flex;
    align-items:center;
    justify-content: center;
    height: 100vh;
    width: 90vw;
`;

const Content =  styled.div`
    background: transparent;
    display: flex;
    justify-content: center;
    width: 90vw;
    height: 90vh;
    min-height: 300px;
    max-height: 500px;

 
`;

const Descricao =  styled.div`
    transition: background .7s linear;
    background: ${props => props.corSortida};
    color: #fff;
    display: flex;
    align-items: center!important;
    min-height: 70vh;
    padding: 40px;
    height: 100%;
   

`;

const DivLogin =  styled.div`
    display: flex;
    align-items: center!important;
   background: white;
    min-height: 70vh;
    padding: 40px;
    height: 100%;

`;

const CadastrarForm = (props) =>{
   
    const handleSubmit = event => {
		event.preventDefault();

		const formData = new FormData(event.target);

		var object = {};
        
		formData.forEach((value, key) => {
			// Reflect.has in favor of: object.hasOwnProperty(key)
			if (!Reflect.has(object, key)) {
				object[key] = value;
				return;
			}
			if (!Array.isArray(object[key])) {
				object[key] = [object[key]];
			}
			object[key].push(value);
		});

		api.post('singup', object)
			.then(res => {
                props.callback();
                toast.success(<h6>Usuario cadastrado</h6>)
			})
			.catch((error) => {
               
        });

	}

    return(
        <Fade in={true}>
            <form onSubmit={handleSubmit} style={{margin: '1rem'}}>
                <div className="row p-0">

                    <div className="col-12 p-0 mb-3">
                        <TextField fullWidth size="small" label="Nome"  name="nome"  />
                    </div>

                    <div className="col-12 p-0 mb-3">
                        <TextField fullWidth size="small" label="Email"  name="email"  />
                    </div>


                    <div className="col-12 p-0 mb-3">
                        <TextField  fullWidth type={'password'} size="small" label="Senha"  name="password"  />
                    </div>

                    <div className="col-12 p-0 mb-3">
                        <TextField fullWidth type={'password'}  size="small" label="Confirmar Senha"  name="confirmPassword"  />
                    </div>

                    <div className="col-12 p-0 mt-2">
                        <Button  style={{background: props.cor}} type="submit" variant="contained" color="primary">Cadastrar</Button>
                    </div>
                    
                    <p className="col-12 p-0 mt-3"><small>já tem uma conta? <a onClick href="#" onClick={() => props.callback()}>Login</a></small></p>
                </div>
            </form>   
        </Fade>
    )
}


const Login = () => {

    const [ email, setEmail] = useState('gileadnetto@hotmail.com');
    const [ password, setpassword] = useState();
    const [ corSortida, setCorSortida] = useState('rgba(43,144,217,0.9)');
    const [ textoDescricao, setTextoDescricao] = useState('');

    const [ cadastrar, setCadastrar] = useState(false);


    const { authenticated, user, handleLogin } = useAuth();

    useEffect(() => {
        typeWriter()
        setInterval(() => {
            setCorSortida(sortearCor());
        }, 10000)
    },[])


    var i = 0;
    const txt = 'Sistema  de controle de estoque e venda voltado para  o comercio de papelaria';
    var speed = 30;

    function typeWriter() {
        if (i < txt.length) {
            document.getElementById("demo").innerHTML += txt.charAt(i);

            i++;
            setTimeout(typeWriter, speed);
        }
    }


    function sortearCor (){
        let corSortidaNew = corSortida;
       
        let min = Math.ceil(0);
        let max = Math.floor(Object.keys(cores).length);

        while(corSortida == corSortidaNew){
            corSortidaNew = cores[Math.floor(Math.random() * (max - min)) + min];
        }

        return corSortidaNew;
    }

    return(
        <Hover>

            <LoginContainer className="container">
                <Content className="row">

                    <Descricao corSortida={corSortida} className="col-12 col-sm-6">
                        <div>
                            <h1><b>Papelaria DEV</b></h1>
                            <p id="demo"></p>
                        </div>
                    </Descricao>

                    <DivLogin className="col-12 col-sm-6">
                        {cadastrar ?
                            <CadastrarForm cor={corSortida} callback={() => setCadastrar(false)}/>
                            :
                            <div className="row p-0">
                                <div className="col-12 p-0">
                                    <TextField  defaultValue={email} fullWidth className="my-2 d.block" label="E-mail" name="usuario" name="usuario" onChange={ evt => setEmail(evt.target.value)} />
                                </div>

                                <div className="col-12 p-0">
                                    <TextField fullWidth className="my-2 d.block" label="Senha" type="password" name="senha" onChange={ evt => setpassword(evt.target.value)} />
                                </div>

                                <div className="my-2 mb-3">
                                    <Button style={{background: corSortida}} variant="contained" color="primary" onClick={() => handleLogin(email, password)}>
                                        Entrar
                                    </Button>
                                </div>

                                <p className="col-12 p-0 mb-0"><small><a href="#">Esqueceu a senha?</a></small></p>
                                <p className="col-12 p-0 mt-0"><small>Não possui uma conta? <a onClick={()=>setCadastrar(true)} href="#">Cadastrar</a></small></p>
                            </div>
                        }

                    </DivLogin>

                </Content>
            </LoginContainer>
        </Hover>
       
    )

}


export default Login;